import { render, staticRenderFns } from "./TjenesteIntegrasjoner.vue?vue&type=template&id=9671e9d8&"
import script from "./TjenesteIntegrasjoner.vue?vue&type=script&lang=ts&"
export * from "./TjenesteIntegrasjoner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports